import PropTypes from "prop-types";
import { useMemo, useState } from "react";

// Components
import SimpleIconButton from "@Layouts/components/Buttons/SimpleIconButton";

// Icons
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

function Expand(props) {
	const { columnsCollapsible, expanded, onExpandAction, setColumnVisibilityModel } = props;
	const [isExpanded, setIsExpanded] = useState(props?.expanded || false);

	const onClickHandler = () => {
		setIsExpanded((prev) => !prev);
		if (!!setColumnVisibilityModel && !!columnsCollapsible?.length) {
			setColumnVisibilityModel?.((prev) => ({
				...prev,
				...Object.fromEntries(columnsCollapsible.map((item) => [item, !isExpanded])),
			}));
		}
		onExpandAction?.(!isExpanded);
	};

	useMemo(() => {
		setIsExpanded(expanded);
	}, [expanded]);

	return (
		<SimpleIconButton
			onClick={onClickHandler}
			icon={
				!isExpanded ? (
					<UnfoldMoreIcon sx={{ transform: "rotate(90deg)" }} />
				) : (
					<UnfoldLessIcon sx={{ transform: "rotate(90deg)" }} />
				)
			}
		/>
	);
}

Expand.propTypes = {
	columnsCollapsible: PropTypes.array,
	expanded: PropTypes.bool,
	onExpandAction: PropTypes.func,
	setColumnVisibilityModel: PropTypes.func,
};

export default Expand;
